"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgHelpCircleInverted(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    width: "22",
    height: "22",
    viewBox: "0 0 22 22"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M11 21C16.5228 21 21 16.5228 21 11C21 5.47715 16.5228 1 11 1C5.47715 1 1 5.47715 1 11C1 16.5228 5.47715 21 11 21Z",
    stroke: "white",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.545 12.4267L11.545 12.4267L11.5452 12.424C11.5617 12.1009 11.6251 11.8675 11.7824 11.6526C11.9426 11.4337 12.2066 11.225 12.6445 10.967L12.6451 10.9667C13.5697 10.4133 14.1293 9.65976 14.1293 8.55664C14.1293 7.77191 13.8071 7.1048 13.2522 6.63544C12.6986 6.16714 11.919 5.9 11.0078 5.9C9.61504 5.9 8.53153 6.48625 8.09344 7.47641C7.96552 7.75376 7.9 8.00709 7.9 8.31738C7.9 8.54471 7.96551 8.73994 8.10111 8.87863C8.23704 9.01765 8.43116 9.0873 8.66309 9.0873C8.84907 9.0873 9.01208 9.0461 9.14782 8.9371C9.28176 8.82955 9.37718 8.66547 9.44869 8.44379L9.44872 8.4438L9.44947 8.44125C9.55376 8.08601 9.73402 7.81728 9.9808 7.63674C10.2278 7.45603 10.5494 7.35781 10.9463 7.35781C11.3808 7.35781 11.7386 7.48996 11.9864 7.71024C12.2333 7.92968 12.3775 8.24212 12.3775 8.61816C12.3775 8.93652 12.3083 9.18522 12.1457 9.41384C11.9806 9.64593 11.7141 9.8647 11.3048 10.1116C10.8536 10.3824 10.5122 10.67 10.2841 11.0077C10.0546 11.3474 9.94395 11.7314 9.94395 12.1865V12.3438C9.94395 12.5858 10.0081 12.8107 10.1466 12.9769C10.2871 13.1456 10.496 13.2436 10.7617 13.2436C11.0072 13.2436 11.1991 13.1631 11.3325 13.0113C11.463 12.8626 11.527 12.6575 11.545 12.4267ZM10.7617 16.1488C11.3276 16.1488 11.7641 15.7232 11.7641 15.167C11.7641 14.6107 11.3276 14.1852 10.7617 14.1852C10.2095 14.1852 9.76621 14.6107 9.76621 15.167C9.76621 15.7232 10.2095 16.1488 10.7617 16.1488Z",
    fill: "white",
    stroke: "white",
    strokeWidth: "0.2"
  }));
}

var _default = SvgHelpCircleInverted;
exports["default"] = _default;